import { render, staticRenderFns } from "./IndicadoresHistoricoPlazosClientes.vue?vue&type=template&id=5c737c80&"
import script from "./IndicadoresHistoricoPlazosClientes.vue?vue&type=script&lang=js&"
export * from "./IndicadoresHistoricoPlazosClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports